import {
  defaultBaseQuery,
  transformErrorResponse,
  transformSuccessResponse,
} from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const divisionAssignmentAPI = createApi({
  reducerPath: "divisionAssignmentAPI",
  baseQuery: defaultBaseQuery,
  tagTypes: ["DivisionAssignment"],
  endpoints: (builder) => ({
    getDivisionAssignmentList: builder.query({
      query: (params) => ({
        url: `/division`,
        method: "GET",
        params,
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
      providesTags: ["DivisionAssignment"],
    }),
    getDivisionAssignmentDropdown: builder.query({
      query: (params) => ({
        url: `/division/dropdown`,
        method: "GET",
        params,
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),
    assignDivision: builder.mutation({
      query: (body) => ({
        url: `/division/assign`,
        method: "PUT",
        body,
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
      invalidatesTags: ["DivisionAssignment"],
    }),
  }),
});

export const {
  useLazyGetDivisionAssignmentListQuery,
  useGetDivisionAssignmentDropdownQuery,
  useAssignDivisionMutation,
} = divisionAssignmentAPI;

export default divisionAssignmentAPI;
